export const regions = ['Africa', 'Americas', 'Asia', 'Europe', 'Oceania']